import { createGlobalStyle } from 'styled-components';

import WecasaBoldWoff from '@wecasa/web-assets/src/fonts/wecasa/Wecasa-Bold.woff';
import WecasaBoldWoff2 from '@wecasa/web-assets/src/fonts/wecasa/Wecasa-Bold.woff2';

import { countryListMobileStyle } from '../components/input-phone/input-phone';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: Wecasa;
    src:
      url(${WecasaBoldWoff2}) format('woff2'),
      url(${WecasaBoldWoff}) format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  :root {
    --font-work-sans: 'Work Sans', sans-serif;
    --font-wecasa: 'Wecasa', 'Work Sans', sans-serif;
    --font-instrument-serif: 'Instrument Serif', serif;
  }
  ${countryListMobileStyle}
`;
